module.exports = {
  "PUBLIC_ANDROID_APP_ID": "com.subsplashconsulting.s_V9572P",
  "PUBLIC_API_DOMAIN_NAME": "api.g3min.org",
  "PUBLIC_API_DOMAIN_NAME_WEB": "api.g3min.org",
  "PUBLIC_API_ENDPOINT": "",
  "PUBLIC_APPLE_ID": "1192776791",
  "PUBLIC_APP_ID": "204",
  "PUBLIC_APP_NAME": "G3 Plus",
  "PUBLIC_AUTH_DOMAIN_NAME": "auth.treefortsystems.com",
  "PUBLIC_AUTH_ENDPOINT": "https://plus.g3min.org",
  "PUBLIC_CDN_ENDPOINT": "https://cdn2.treefortsystems.com",
  "PUBLIC_CLIENT_ID_WEB": "562790f6-49ef-484b-9a2c-0d660857f4cd",
  "PUBLIC_DEBUG": "",
  "PUBLIC_DOMAIN_NAME": "plus.g3min.org",
  "PUBLIC_EAS_PROJECT_ID": "713ac9a1-615c-4a21-ab3f-97c760c3feca",
  "PUBLIC_EAS_UPDATE_CHANNEL": "prd_g3",
  "PUBLIC_ENV": "production",
  "PUBLIC_FIREBASE_CONFIG_WEB": "eyJhcHBJZCI6IjE6ODYwMTc5ODU2Mzk0OndlYjpmYjM5ZjIyMTU0MWZkNzg3NzI3M2YzIiwiYXBpS2V5IjoiQUl6YVN5QjdfeTZ5WVF5T2Q3Z0pPRklscklwUG9yZWlobTgwUGQ4IiwicHJvamVjdElkIjoiZzMtcGx1cyIsImF1dGhEb21haW4iOiJnMy1wbHVzLmZpcmViYXNlYXBwLmNvbSIsIm1lYXN1cmVtZW50SWQiOiJHLUNEODZWOThEME4iLCJzdG9yYWdlQnVja2V0IjoiZzMtcGx1cy5hcHBzcG90LmNvbSIsIm1lc3NhZ2luZ1NlbmRlcklkIjoiODYwMTc5ODU2Mzk0In0=",
  "PUBLIC_FIREBASE_MESSAGING_VAPID_PUBLIC_KEY": "BGPuEeNP7vxD9mx91u3lQcUDIXkoXTeIZfz51RYvxGE9ipVKMjB5mb26SPidVCO7QV6bIWmuE5DES8CVtGBAIJY",
  "PUBLIC_GOOGLE_SITE_VERIFICATION_TOKEN": "",
  "PUBLIC_ICON_BACKGROUND_COLOR": "#ffffff",
  "PUBLIC_ICON_FOREGROUND_IMAGE_PADDING": "51",
  "PUBLIC_ICON_FOREGROUND_IMAGE_URL": "https://cdn2.treefortsystems.com/public/a963f031-d6e7-4cad-bc4f-043a51ceee0b/uploads/f52173fd-ddf2-4258-884c-c5f094653537.png",
  "PUBLIC_IOS_BUNDLE_ID": "com.subsplashconsulting.V9572P",
  "PUBLIC_MANIFEST_URL": "",
  "PUBLIC_META_PIXEL_ID": "",
  "PUBLIC_OBJECT_STORAGE_CDN_ENDPOINT": "https://cdn.treefortsystems.com/file/treefort-ott-prod",
  "PUBLIC_PAYMENT_FREEDOM_GRANTED_WEB": "true",
  "PUBLIC_REGION_ENDPOINT": "https://media.treefortsystems.com/region",
  "PUBLIC_RUDDERSTACK_WRITE_KEY_WEB": "2R7bbPp2nT47PLlu64DVEGI2exS",
  "PUBLIC_SENTRY_DSN_WEB": "https://2a13400a30ad4037a8f0cf127af14bff@o1003299.ingest.sentry.io/5966172",
  "PUBLIC_SENTRY_ENABLE_EVENTS": "true",
  "PUBLIC_SENTRY_PROFILES_SAMPLE_RATE": "0.5",
  "PUBLIC_SENTRY_TRACES_SAMPLE_RATE": "0.005",
  "PUBLIC_SINGULAR_APP_ID_WEB": "",
  "PUBLIC_SINGULAR_SDK_KEY": "",
  "PUBLIC_SINGULAR_SDK_SECRET": "",
  "PUBLIC_SPLASH_BACKGROUND_COLOR": "",
  "PUBLIC_SPLASH_LOGO_URL": "",
  "PUBLIC_SPLASH_LOGO_WIDTH": "",
  "PUBLIC_SPLASH_SCREEN_BACKGROUND_COLOR": "#ffffff",
  "PUBLIC_SPLASH_SCREEN_FOREGROUND_IMAGE_URL": "https://cdn2.treefortsystems.com/public/a963f031-d6e7-4cad-bc4f-043a51ceee0b/uploads/b8c2e3d3-20ba-4e6c-96cb-db020d7712d7.png",
  "PUBLIC_SPLASH_SCREEN_FOREGROUND_IMAGE_WIDTH": "135",
  "PUBLIC_TENANT_ID": "a963f031-d6e7-4cad-bc4f-043a51ceee0b",
  "PUBLIC_MAJOR_VERSION": "33",
  "PUBLIC_MINOR_VERSION": "2",
  "PUBLIC_PATCH_VERSION": "4",
  "PUBLIC_SENTRY_DIST": "v0",
  "PUBLIC_SENTRY_RELEASE_WEB": "plus.g3min.org@33.2.4",
  "PUBLIC_SPLASH_SCREEN_DISPLAY_MODE": "light"
}
